import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { RenuevaSessionComponent } from '../components/renuevaSession/renuevaSession.component';

@Injectable({
    providedIn: 'root'
})
export class DialogServiceRenuevaSession {

    private modalService: NgbModal = inject(NgbModal);

    public open(title: string, message: string, showCancel = false, confirmText = 'Ok', cancelText = 'Cancel',
        options: NgbModalOptions = { size: 'sm' }) {
        this.modalService.dismissAll();
        const modalRef = this.modalService.open(RenuevaSessionComponent, options);

        const instance = (modalRef as any)._windowCmptRef.instance;

        setTimeout(() => {
            instance.windowClass = 'custom-show';
        }, 0);

        const fx = (modalRef as any)._removeModalElements.bind(modalRef);
        (modalRef as any)._removeModalElements = () => {
            instance.windowClass = '';
            setTimeout(fx, 250);
        }

        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.showCancel = showCancel;
        modalRef.componentInstance.confirmText = confirmText;
        modalRef.componentInstance.cancelText = cancelText;
        modalRef.componentInstance.changeRef.markForCheck();
        return modalRef.result;
    }
    public closeall() {
        this.modalService.dismissAll();
    }
}
